import { render, staticRenderFns } from "./ResearchListing.vue?vue&type=template&id=bbc75a5e&"
import script from "./ResearchListing.vue?vue&type=script&lang=js&"
export * from "./ResearchListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports